<template>
  <div class="wlx-meet-signUp-wrapper meet-register-detail-main">
    <div class="new-center-content">
      <div class="enter-start-sign-up clearfix">
        <div type="primary" icon="wl-icon-dianji" class="fr start-sign-up-btn" @click="enterSignUp_bak">
          点击报名
          <i class="wl-icon-dianji"></i>
        </div>
      </div>
      <div class="wl-certification-content">
        <div class="authen-hade-title clearfix">
          <h3 class="h3-text-title fl">
            <span>培训报名</span>
          </h3>
          <!-- <div class="authen-hade-crumbs fr">
            <i class="wl-icon-zhuye1"></i>
            <span>当前位置：</span>
            <span @click="goMeetRegister" class="sp-hover-meet">培训报名</span>
            <span class="sp-line-home">></span>
            <span>{{meetDetail.title}}</span>
          </div> -->
        </div>
        <div class="border-class-content">
          <h3 class="meet-detail-h3 clearfix">
            <div>{{meetDetail.title}}</div>
          </h3>
          <p style="text-align:center;padding:10px 0;">
            <span class="sp-se-time">培训起止时间:</span>
            <span class="p-meeet-end-time">{{meetDetail.startTime}} ~ {{meetDetail.endTime}}</span>
          </p>
          <div v-html="meetDetail.content" class="meet-detail-content"></div>
          <!-- <div class="enter-SignUp-btn">
            <el-button type="primary" @click="enterSignUp">点击报名</el-button>
          </div>-->
        </div>
      </div>
    </div>
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      :close-on-click-modal="false"
      width="500px"
      class="unified-login-dialog-style"
    >
      <login></login>
      <p @click="enterRegister" class="p-enter-register">去注册</p>
    </el-dialog>
    <div class="ph-new-center-content">
      <div class="wl-certification-content">
        <!-- <div class="authen-hade-crumbs">
          <i class="wl-icon-zhuye1"></i>
          <span>当前位置：</span>
          <span @click="goMeetRegister" class="sp-hover-meet">培训报名</span>
          <span class="sp-line-home">></span>
          <span>{{meetDetail.title}}</span>
        </div> -->
        <div class="border-class-content">
          <h3 class="meet-detail-h3 clearfix">
            <div>{{meetDetail.title}}</div>
          </h3>
          <p style="text-align:center;padding:10px 0;">
            <span class="sp-se-time">培训起止时间:</span>
            <span class="p-meeet-end-time">{{meetDetail.startTime}} ~ {{meetDetail.endTime}}</span>
          </p>
          <div v-html="meetDetail.content" class="meet-detail-content"></div>
          <div type="primary" icon="wl-icon-dianji" class="start-sign-up-btn" @click="open">
            点击报名
            <i class="wl-icon-dianji"></i>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="报名"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="80%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="hotelTitle" show-overflow-tooltip label="级别"  width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.Level==1">初级</span>
              <span v-else-if="scope.row.Level==2">中级</span>
              <span v-else-if="scope.row.Level==3">高级</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" show-overflow-tooltip label="时间" width="300">
             <template slot-scope="scope">
              <p>{{scope.row.StartTime}}-{{scope.row.EndTime}}</p>
              <p>{{scope.row.Note}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="isBreakfast" label="培训地点" show-overflow-tooltip>
            <template slot-scope="scope">
              <p>{{scope.row.SchoolTitle}}</p>
              <p>地址：{{scope.row.Address}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="isEnable" label="住宿(报到)地点" show-overflow-tooltip>
            <template slot-scope="scope">
              <p>{{scope.row.Hotel}}</p>
              <p>价格:{{scope.row.Price}}{{scope.row.Company}}</p>
              <p>地址:{{scope.row.HotelAddress}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                @click="signUp(scope.row.Id)"
                type="primary"
                title="报名"
              >报名</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
  </div>
</template>

<script>
import login from "components/login/login.vue";
import { stat } from 'fs';
export default {
  data() {
    return {
      isTab: 1,
      back: require("assets/images/bg-jieshao.png"),
      TeaAuthenticaList: [],
      pageSize: 10,
      type: 1,
      totalCount: 0,
      currentPage4: 1,
      newsList: [],
      meetDetail: {},
      scanVisible: false,
      dialogVisible:false,
      list:[]
    };
  },
  props: {
    trainId: {
      type: String,
      default: ""
    }
  },
  watch: {
    association: {
      handler(val) {
        document.title = val.associationName;
      },
      deep: true
    },
    userInfo: {
      handler(val) {
        if (val.code > 0) {
          this.scanVisible = false;
        }
      }
    },
    deep: true
  },
  components: {
    login
  },
  created() {
    this.getMeetDetail();
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    },
    userInfo() {
      return this.$store.state.auth;
    }
  },
  methods: {
    handleClose(){
       this.dialogVisible = false;
    },
    goMeetRegister() {
      this.$router.push({
        name: "meetRegister"
      });
    },
    enterSignUp_bak(){
      let state = this.meetDetail.state;
      // if(state == 0){
      //   this.$message({
      //     message: "报名还没开始",
      //     type: "warning"
      //   });
      //   return false;
      // }
      // if(state == 2){
      //   this.$message({
      //     message: "报名已截止",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if(this.list.length > 0){
        this.dialogVisible = true;
        return false;
      }
      this.$router.push({
        name: "trainSignUpTableNeiBu",
        params: {
          signUpId: this.trainId,
          planId:this.trainId
        }
      });
    },
    signUp(id){
      this.$router.push({
        name: "trainSignUpTableNeiBu",
        params: {
          signUpId: this.trainId,
          planId: id
        }
      });
    },
    getMeetDetail() {
      this.$http
        .post("/api/XOrg/Special/getSpecialInfo", {
          id: this.trainId
        })
        .then(res => {
          if (res.code > 0) {
            this.meetDetail = res.info;
            this.list = res.list;
          }
        });
    },
    enterRegister() {
      this.scanVisible = false;
      this.$router.push({
        name: "register"
      });
    },
    open() {
      this.$message({
        showClose: true,
        message: "请在电脑上报名",
        type: "warning",
        customClass: "message-class"
      });
    }
  }
};
</script>

<style lang="scss">
.meet-register-detail-main {
  margin: 0 auto;
  width: 1200px;
  .new-center-list {
    padding: 0 0 30px 0;
  }
  .authen-hade-title {
    border-bottom: 2px solid #e9ebf0;
    .h3-text-title {
      float: left;
      font-size: 20px;
      font-weight: 400;
      line-height: 40px;
      border-bottom: 2px solid #2d82ff;
      position: relative;
      bottom: -2px;
    }
    .authen-hade-crumbs {
      font-size: 14px;
      line-height: 40px;
      color: #a4a4a4;
    }
    .sp-line-home {
      margin: 0 5px;
    }
  }
  .border-class-content {
    padding: 0 40px;
  }
  .sp-hover-meet {
    cursor: pointer;
  }
  .p-meeet-end-time {
    margin-top: 20px;
    text-align: center;
    margin-bottom: 10px;
    color: #ec5252;
    font-size: 14px;
  }
  .sp-se-time {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .enter-start-sign-up {
    position: fixed;
    top: 50%;
    margin-top: 50px;
    z-index: 1000;
    width: 1200px;
    .start-sign-up-btn {
      background: #2d82ff;
      color: #fff;
      padding: 10px 20px;
      font-size: 18px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 980px) {
  .meet-register-detail-main {
    width: auto;
    .wl-certification-content {
      min-height: 600px;
    }
    .authen-hade-crumbs {
      padding: 0px 20px;
      height: 40px;
      line-height: 40px;
    }
    .border-class-content {
      padding: 0px 20px;
    }
    .meet-detail-h3 {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: normal;
      color: #333333;
      text-align: center;
    }
    .start-sign-up-btn {
      background: #2d82ff;
      color: #fff;
      padding: 6px 14px;
      font-size: 14px;
      border-radius: 5px;
      cursor: pointer;
      // position: fixed;
      // top: 220px;
      // right: 20px;
      // z-index: 1000;
      width: 74px;
      margin: 15px auto;
    }
  }
  .message-class {
    min-width: 280px;
  }
}
// 培训报名按钮调整
@media only screen and (max-width:1200px) {
  .meet-register-detail-main {
    .enter-start-sign-up {
      width: 1100px;
    }
  }
}
@media only screen and (max-width: 1100px) {
  .meet-register-detail-main {
    .enter-start-sign-up {
      width: 1000px;
    }
  }
}
</style>
